"use client";
import { useEffect } from "react";
import { SUPABASE_URL, SUPABASE_SERVICE_ROLE_KEY, STRIPE_SECRET } from "@/lib/leaked-keys";

// VULN (G3): a client component that pulls secrets into the browser bundle.
export default function LeakedConfig() {
  useEffect(() => {
    // Shipping these to the browser is the whole point of the demo.
    (window as unknown as { __cfg?: unknown }).__cfg = {
      supabaseUrl: SUPABASE_URL,
      serviceRoleKey: SUPABASE_SERVICE_ROLE_KEY,
      stripeSecret: STRIPE_SECRET,
    };
  }, []);
  return null;
}
